// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fair-play-add-extra-penalty-modal .modal2__container {
    width: 40%;
    min-width: 533px;
}

.fair-play-add-extra-penalty-modal .form {
    padding: 0 44px 24px 44px;
}

.fair-play-add-extra-penalty-modal .form .input-field-input,
.fair-play-add-extra-penalty-modal .form .select-field-input,
.fair-play-add-extra-penalty-modal .form .input-field-multiline-input {
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.fair-play-add-extra-penalty-modal .form .input-field-label,
.fair-play-add-extra-penalty-modal .form .select-field-label,
.fair-play-add-extra-penalty-modal .form .input-field-multiline-label {
    color: var(--primary-very-dark-color);
    font-size: calc(var(--space) - 2px);
    font-weight: var(--font-regular);
    text-transform: unset;
}

.fair-play-add-extra-penalty-modal .form .select-field,
.fair-play-add-extra-penalty-modal .form .input-field {
    margin-bottom: 0;
    margin-top: 44px;
}

.fair-play-add-extra-penalty-modal .form .select-field .MuiTypography-root {
    color: var(--primary-very-dark-color);
}

.fair-play-add-extra-penalty-modal .form .input-field-multiline {
    margin-bottom: 0;
    margin-top: 24px;
} 


.fair-play-add-extra-penalty-modal .form .search_members_staff_edit_content .MuiListItem-container {
    background: var(--white-color);
}

.fair-play-add-extra-penalty-modal .form .search_members_staff_edit_content .input-field-autocomplete__list.MuiListItem-gutters {
    padding-top: 2px;
    padding-bottom: 2px;
}

.fair-play-add-extra-penalty-modal .form .search_members_staff_edit_content .input-field-autocomplete__list__icon {
    margin-right: 8px;
}

.fair-play-add-extra-penalty-modal .form .search_members_staff_edit_content {
    padding: 0;
    padding-top: 4px;
}

.fair-play-add-extra-penalty-modal .form .baloa-table-column {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
    margin-top: 24px;
}

.fair-play-add-extra-penalty-modal__short-input {
    width: 170px;
}

.fair-play-add-extra-penalty-modal__switch {
    margin-top: 24px;
}

.fair-play-add-extra-penalty-modal__switch.MuiFormControlLabel-root {
    margin-left: 0;
    margin-right: 0;
}

.fair-play-add-extra-penalty-modal .form .fair-play-add-extra-penalty-modal__switch .baloa-table-column {

    font-weight: var(--font-medium);
    margin-top: 0px;
}

.fair-play-add-extra-penalty-modal__buttons {
    border-top: 1px solid var(--new-gray-background-color);
    padding: 12px 16px;
    width: 100%;
    text-align: end;
}

.fair-play-add-extra-penalty-modal__buttons .button {
    margin-left: auto;
    padding: 10px 20px;
}

.fair-play-add-extra-penalty-modal .form .base-Popper-root  {
    margin-left: -40px !important;
}

.fair-play-add-extra-penalty-modal .form .MuiPopper-root  {/*Windows*/
    margin-left: -40px !important;
}

.fair-play-add-extra-penalty-modal__selected-match .baloa-table {
    font-size: calc(var(--space-half-quarter) + var(--space-eighth));
}

.fair-play-add-extra-penalty-modal__selected-match .baloa-names {
    font-size: var(--space);
}

.fair-play-add-extra-penalty-modal__selected-match .baloa-normal-medium {
    font-size: calc(var(--space) + var(--space-quarter));
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-fair-play-add-extra-penalty/TournamentFairPlayAddExtraPenaltyModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;;;IAGI,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,sDAAsD;IACtD,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA,2DAA2D,UAAU;IACjE,6BAA6B;AACjC;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oDAAoD;AACxD","sourcesContent":[".fair-play-add-extra-penalty-modal .modal2__container {\n    width: 40%;\n    min-width: 533px;\n}\n\n.fair-play-add-extra-penalty-modal .form {\n    padding: 0 44px 24px 44px;\n}\n\n.fair-play-add-extra-penalty-modal .form .input-field-input,\n.fair-play-add-extra-penalty-modal .form .select-field-input,\n.fair-play-add-extra-penalty-modal .form .input-field-multiline-input {\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.fair-play-add-extra-penalty-modal .form .input-field-label,\n.fair-play-add-extra-penalty-modal .form .select-field-label,\n.fair-play-add-extra-penalty-modal .form .input-field-multiline-label {\n    color: var(--primary-very-dark-color);\n    font-size: calc(var(--space) - 2px);\n    font-weight: var(--font-regular);\n    text-transform: unset;\n}\n\n.fair-play-add-extra-penalty-modal .form .select-field,\n.fair-play-add-extra-penalty-modal .form .input-field {\n    margin-bottom: 0;\n    margin-top: 44px;\n}\n\n.fair-play-add-extra-penalty-modal .form .select-field .MuiTypography-root {\n    color: var(--primary-very-dark-color);\n}\n\n.fair-play-add-extra-penalty-modal .form .input-field-multiline {\n    margin-bottom: 0;\n    margin-top: 24px;\n} \n\n\n.fair-play-add-extra-penalty-modal .form .search_members_staff_edit_content .MuiListItem-container {\n    background: var(--white-color);\n}\n\n.fair-play-add-extra-penalty-modal .form .search_members_staff_edit_content .input-field-autocomplete__list.MuiListItem-gutters {\n    padding-top: 2px;\n    padding-bottom: 2px;\n}\n\n.fair-play-add-extra-penalty-modal .form .search_members_staff_edit_content .input-field-autocomplete__list__icon {\n    margin-right: 8px;\n}\n\n.fair-play-add-extra-penalty-modal .form .search_members_staff_edit_content {\n    padding: 0;\n    padding-top: 4px;\n}\n\n.fair-play-add-extra-penalty-modal .form .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n    margin-top: 24px;\n}\n\n.fair-play-add-extra-penalty-modal__short-input {\n    width: 170px;\n}\n\n.fair-play-add-extra-penalty-modal__switch {\n    margin-top: 24px;\n}\n\n.fair-play-add-extra-penalty-modal__switch.MuiFormControlLabel-root {\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.fair-play-add-extra-penalty-modal .form .fair-play-add-extra-penalty-modal__switch .baloa-table-column {\n\n    font-weight: var(--font-medium);\n    margin-top: 0px;\n}\n\n.fair-play-add-extra-penalty-modal__buttons {\n    border-top: 1px solid var(--new-gray-background-color);\n    padding: 12px 16px;\n    width: 100%;\n    text-align: end;\n}\n\n.fair-play-add-extra-penalty-modal__buttons .button {\n    margin-left: auto;\n    padding: 10px 20px;\n}\n\n.fair-play-add-extra-penalty-modal .form .base-Popper-root  {\n    margin-left: -40px !important;\n}\n\n.fair-play-add-extra-penalty-modal .form .MuiPopper-root  {/*Windows*/\n    margin-left: -40px !important;\n}\n\n.fair-play-add-extra-penalty-modal__selected-match .baloa-table {\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth));\n}\n\n.fair-play-add-extra-penalty-modal__selected-match .baloa-names {\n    font-size: var(--space);\n}\n\n.fair-play-add-extra-penalty-modal__selected-match .baloa-normal-medium {\n    font-size: calc(var(--space) + var(--space-quarter));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
